module.exports = __webpack_public_path__ + "static/media/blockchain3.102b1eb8.svg";